import { forwardRef, useMemo } from "react";
import { Input, Select, Flex, Box, Text } from "@chakra-ui/react";
import { TweetLabels } from "components/tweet-labels";

export const MatchString = forwardRef(
  (
    {
      // @ts-ignore
      column: { filterValue, preFilteredRows, setFilter },
      // @ts-ignore
      placeholder = "",
    },
    ref,
  ) => {
    const count = preFilteredRows?.length;

    return (
      <Input
        value={filterValue || ""}
        // @ts-ignore
        ref={ref}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={placeholder || `Search ${count} records...`}
      />
    );
  },
);

export const SelectFilter = forwardRef(
  // @ts-ignore
  ({ column: { filterValue, setFilter } }, ref) => {
    return (
      <Select
        value={filterValue}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}
        // @ts-ignore
        ref={ref}
      >
        <option value="">All</option>
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </Select>
    );
  },
);

export const websiteFilter = (rows, id, filterValue) => {
  if (!filterValue) {
    return rows;
  }

  return rows.filter((row) => {
    const rowValue = row.values[id];
    if (filterValue === "yes") {
      return rowValue;
    }

    return !rowValue;
  });
};

export const NumberRangeFilter = forwardRef(
  (
    {
      // @ts-ignore
      column: { filterValue = [], preFilteredRows, setFilter, id },
    },
    ref,
  ) => {
    const [min, max] = useMemo(() => {
      let min = preFilteredRows?.length ? preFilteredRows[0].values[id] : 0;
      let max = preFilteredRows?.length ? preFilteredRows[0].values[id] : 0;
      preFilteredRows.forEach((row) => {
        min = Math.min(row.values[id], min);
        max = Math.max(row.values[id], max);
      });
      return [min, max];
    }, [id, preFilteredRows]);

    return (
      <Flex alignItems="center" justifyContent="center">
        <Input
          value={filterValue[0] || ""}
          type="number"
          // @ts-ignore
          ref={ref}
          min={0}
          w="32"
          mr="2"
          onChange={(e) => {
            const val = e.target.value;
            setFilter((old = []) => [
              val ? parseInt(val, 10) : undefined,
              old[1],
            ]);
          }}
          placeholder={`Min (${min})`}
        />
        to
        <Input
          value={filterValue[1] || ""}
          min={0}
          type="number"
          w="32"
          ml="2"
          onChange={(e) => {
            const val = e.target.value;
            setFilter((old = []) => [
              old[0],
              val ? parseInt(val, 10) : undefined,
            ]);
          }}
          placeholder={`Max (${max})`}
        />
      </Flex>
    );
  },
);

export const PreviewTextFilterUI = forwardRef(
  (
    {
      // @ts-ignore
      column: { filterValue, setFilter },
    },
    ref,
  ) => {
    return (
      <Box>
        <Box>
          <Text ml="1" mb="2" textTransform="none">
            Filter by text:
          </Text>
          <Input
            // @ts-ignore
            ref={ref}
            value={filterValue?.text || ""}
            onChange={(e) => {
              setFilter({
                ...filterValue,
                text: e.target.value || "",
              });
            }}
            placeholder="Search text..."
          />
        </Box>
        <Box ml="1" mt="4">
          <Text textTransform="none">Filter by labels: </Text>
          <TweetLabels
            size="xs"
            mainContainerProps={{
              mt: "2",
              justify: "left",
              textTransform: "initial",
            }}
            selectedLabelIds={filterValue?.labels ?? []}
            onChange={(labels) =>
              setFilter({
                ...filterValue,
                labels,
              })
            }
            showAddLabelButton={false}
            showEditLabelOption={false}
          />
        </Box>
      </Box>
    );
  },
);

export const previewTextFilter = (rows, id, filterValue) => {
  if (
    !filterValue?.text &&
    (!filterValue?.labels || filterValue?.labels?.length === 0) &&
    !filterValue?.isThreadsOnly
  ) {
    return rows;
  }

  return rows.filter((row) => {
    const rowValue = row.values[id];
    let trimmedText = rowValue?.tweet?.full_text?.trim();
    trimmedText = trimmedText?.includes("http")
      ? trimmedText?.slice(0, trimmedText?.lastIndexOf("http"))
      : trimmedText;
    trimmedText = trimmedText?.trim();

    const textCondition = !filterValue.text
      ? true
      : rowValue.text?.includes(filterValue.text);
    const labelsCondition =
      !filterValue?.labels || filterValue?.labels?.length === 0
        ? true
        : rowValue?.tweet?.labels?.some((l) =>
            filterValue?.labels?.includes(l),
          );
    const isThreadsOnly = !filterValue.isThreadsOnly
      ? true
      : rowValue.tweet?.tweetDetails?.threadTweets?.length > 1 ||
        rowValue.tweet?.tweetDetails?.text.includes("\n\n\n");

    if (textCondition && labelsCondition && isThreadsOnly) {
      return true;
    }

    return false;
  });
};
